import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ContentContext, DEFAULT_CONTENT } from "@/lib/content";
import { Navbar } from "@/components/site/Navbar";
import { FloatingCTA } from "@/components/site/FloatingCTA";
import { Hero } from "@/components/site/Hero";
import { EditorialMarquee } from "@/components/site/Marquee";
import { About } from "@/components/site/About";
import { Resume } from "@/components/site/Resume";
import { Training } from "@/components/site/Training";
import { Services } from "@/components/site/Services";
import { Testimonials } from "@/components/site/Testimonials";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export default function Home() {
  const [content, setContent] = useState(DEFAULT_CONTENT);

  useEffect(() => {
    api.get("/content")
      .then(({ data }) => setContent((c) => ({ ...c, ...data })))
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!window.location.hash) return;
    let tries = 0;
    let timer;
    const go = () => {
      const el = document.querySelector(window.location.hash);
      if (el) el.scrollIntoView({ behavior: "auto", block: "start" });
      if (++tries < 5) timer = setTimeout(go, 300);
    };
    timer = setTimeout(go, 400);
    return () => clearTimeout(timer);
  }, []);

  return (
    <ContentContext.Provider value={content}>
      <main data-testid="home-page">
        <Navbar />
        <FloatingCTA />
        <Hero />
        <EditorialMarquee />
        <About />
        <Resume />
        <Training />
        <Services />
        <Testimonials />
        <Contact />
        <Footer />
      </main>
    </ContentContext.Provider>
  );
}
